module.exports = __webpack_public_path__ + "static/media/lv_ru.5c17ab86.png";